import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

import Layout from '@/views/Layout/index.vue'
import Login from '@/views/Login/index.vue'
import Dashboard from '@/views/Dashboard/index.vue'
import Products from '@/views/Products/index.vue'
import Review from '@/views/Review/index.vue'
import PuhuiOrders from '@/views/PuhuiOrders/index.vue'
import ReportOrders from '@/views/ReportOrders/index.vue'
import Members from '@/views/Members/index.vue'
import Accounts from '@/views/Accounts/index.vue'
import Finance from '@/views/Finance/index.vue'
import Leaderboard from '@/views/Leaderboard/index.vue'
import MerchantAudit from '@/views/MerchantAudit/index.vue'
import AfterSales from '@/views/AfterSales/index.vue'
import AfterSaleDetail from '@/views/AfterSales/detail.vue'
import CloudWarehouse from '@/views/CloudWarehouse/index.vue'
import SystemAdmins from '@/views/System/Admins.vue'
import SystemRoles from '@/views/System/Roles.vue'
import SystemPermissions from '@/views/System/Permissions.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: '首页数据', icon: 'el-icon-s-data' }
      },
      {
        path: 'products',
        name: 'Products',
        component: Products,
        meta: { title: '普惠商品管理', icon: 'el-icon-goods' }
      },
      {
        path: 'review',
        name: 'Review',
        component: Review,
        meta: { title: '报单商品审核', icon: 'el-icon-document-checked' }
      },
      {
        path: 'orders/puhui',
        name: 'PuhuiOrders',
        component: PuhuiOrders,
        meta: { title: '普惠订单', icon: 'el-icon-s-order' }
      },
      {
        path: 'orders/report',
        name: 'ReportOrders',
        component: ReportOrders,
        meta: { title: '报单订单', icon: 'el-icon-tickets' }
      },
      {
        path: 'members',
        name: 'Members',
        component: Members,
        meta: { title: '全平台会员', icon: 'el-icon-user-solid' }
      },
      {
        path: 'accounts',
        name: 'Accounts',
        component: Accounts,
        meta: { title: '分身账号管理', icon: 'el-icon-key' }
      },
      {
        path: 'finance',
        name: 'Finance',
        component: Finance,
        meta: { title: '平台财务', icon: 'el-icon-money' }
      },
      {
        path: 'leaderboard',
        name: 'Leaderboard',
        component: Leaderboard,
        meta: { title: '龙虎榜', icon: 'el-icon-trophy' }
      },
      {
        path: 'merchant-audit',
        name: 'MerchantAudit',
        component: MerchantAudit,
        meta: { title: '会员商户信息审核', icon: 'el-icon-s-check' }
      },
      {
        path: 'after-sales',
        name: 'AfterSales',
        component: AfterSales,
        meta: { title: '售后管理', icon: 'el-icon-service' }
      },
      {
        path: 'after-sales/:id',
        name: 'AfterSaleDetail',
        component: AfterSaleDetail,
        meta: { title: '售后详情', hidden: true }
      },
      {
        path: 'cloud-warehouse',
        name: 'CloudWarehouse',
        component: CloudWarehouse,
        meta: { title: '托管商品管理', icon: 'el-icon-box' }
      },
      // RBAC 系统管理
      {
        path: 'system/admins',
        name: 'SystemAdmins',
        component: SystemAdmins,
        meta: { title: '管理员管理', icon: 'el-icon-user' }
      },
      {
        path: 'system/roles',
        name: 'SystemRoles',
        component: SystemRoles,
        meta: { title: '角色管理', icon: 'el-icon-s-custom' }
      },
      {
        path: 'system/permissions',
        name: 'SystemPermissions',
        component: SystemPermissions,
        meta: { title: '权限管理', icon: 'el-icon-lock' }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 登录守卫 + 用户信息获取
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')
  if (to.path !== '/login' && !token) {
    next('/login')
  } else if (to.path === '/login' && token) {
    next('/dashboard')
  } else {
    // 如果有 token 且还没拉取用户信息，先拉取
    if (token && to.path !== '/login' && store.state.permissions.length === 0) {
      store.dispatch('fetchUserInfo').then(() => {
        next()
      }).catch(() => {
        next('/login')
      })
    } else {
      next()
    }
  }
})

export default router
